import template from './bIndeterminateCheckbox.html';

export function bIndeterminateCheckboxDirective() {
  'ngInject';
  return {
    restrict: 'E',
    template: template,
    controller: bIndeterminateCheckboxController,
    controllerAs: 'bIndeterminateCheckbox',
    bindToController: true,
    scope: {
      ngModel: '=',
      onChange: '&'
    }
  };
}

class bIndeterminateCheckboxController {
  constructor() {
    'ngInject';
  }

  hasState() {
    return this.ngModel === null || this.ngModel === true;
  }

  changeState(){
    this.ngModel = !this.ngModel;
    setTimeout(() => {
      this.onChange({});
    }, 2);

  }
}
